import { DialogMessenger, CallbackDatabase } from './dialogMessenger';
import { logSentryError, SentryContext } from 'utils/loggingUtil';

//!!!Do not change as long as old addin is around!!!
export const IndexDBDialogMessengerName = 'IndexDbDialogMessenger';
export class IndexDBDialogMessenger extends DialogMessenger {
    private db: CallbackDatabase;
    private asyncCallbacks: {
        [key: string]: (result: Office.AsyncResult<any>) => void;
    } = {};

    private runningPullTimer = null;
    private proxyCounter = 0;

    constructor() {
        super();
        this.runningPullTimer = setInterval(() => this.timeoutFunc(), 100);
        this.db = new CallbackDatabase();
        this.db.version(1).stores({
            callbacks: 'id'
        });
    }

    private async timeoutFunc() {
        let keys = Object.keys(this.asyncCallbacks);
        for (const key of keys) {
            let value = await this.getData(key);
            if (value) {
                this.handleCallback(key, value);
            }
        }
    }

    private handleCallback(key: string, newValue: string) {
        //Deserialize & execute callback method
        let data = JSON.parse(newValue).args;
        if (this.asyncCallbacks[key] && typeof (this.asyncCallbacks[key]) === 'function')
            this.asyncCallbacks[key].apply(this, data);
        //Clear callback & storage of result
        delete this.asyncCallbacks[key];
        this.db.callbacks.delete(key);
    }

    async getData(key: string): Promise<string> {
        let data = null;
        try {
            data = await this.db.callbacks.get({ id: key });
        }
        catch (e) {
            //e.inner as described on https://dexie.org/docs/DexieErrors/Dexie.AbortError
            logSentryError(e, SentryContext.browser, { message: 'Error in indexDB.getData', inner: JSON.stringify(e?.inner) });

            return null;
        }

        if (data) {
            return data.value;
        }
        else {
            return null;
        }
    }

    async setData(key: string, message: string) {
        await this.db.callbacks.put({ id: key, value: message });
    }

    cleanup() {
        try {
            this.db.callbacks.clear();
        }
        catch (e) {
            logSentryError(e, SentryContext.browser, { message: 'error while clearing data' });
        }
    }

    callAsyncMethod(message: any, callback: (data: any) => void) {
        let cbkId = null;
        if (callback && typeof (callback) === 'function') {
            cbkId = "dialog-cbk-" + new Date().getTime().toString() + "-" + this.proxyCounter++;
            this.asyncCallbacks[cbkId] = callback;
        }
        message.callbackId = cbkId;
        message.type = 'callAsync';
        Office.context.ui.messageParent(JSON.stringify(message));

    }

    getName() {
        return IndexDBDialogMessengerName;
    }
}
